import { Sparkles, Check, Github } from "lucide-react";
import { AI_TOOLS } from "../../data/services";
import Reveal from "../Reveal";

export const AICapabilities = () => {
  return (
    <section
      id="ai"
      data-testid="ai-section"
      className="relative z-10 py-24 md:py-32 bg-[#f4f3ee] border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#2f4bff]">
                / AI-assisted engineering
              </span>
              <h2 className="mt-5 font-head text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight max-w-2xl leading-[1.02] text-[#111111]">
                Building with modern AI, every day.
              </h2>
              <p className="mt-5 font-body text-lg text-neutral-600 max-w-xl leading-relaxed">
                I integrate leading AI models into my development workflow —
                through GitHub Copilot and directly — to ship faster and cleaner.
                AI accelerates the work; the engineering judgment, review and
                testing stay firmly with me.
              </p>
            </div>
            <div
              data-testid="ai-copilot-badge"
              className="inline-flex items-center gap-2.5 shrink-0 border border-black/15 bg-white px-5 py-3"
            >
              <Github className="h-5 w-5 text-[#111111]" />
              <span className="font-mono-tech text-xs uppercase tracking-[0.15em] text-neutral-700">
                GitHub Copilot
              </span>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {AI_TOOLS.map((tool, i) => (
            <Reveal key={tool.id} delay={i * 0.07}>
              <div
                data-testid={`ai-card-${tool.id}`}
                className="group h-full flex flex-col bg-white border border-black/10 p-8 md:p-10 hover:border-[#2f4bff] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-center justify-between">
                  <Sparkles className="h-6 w-6 text-[#2f4bff]" />
                  <span className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-neutral-400 border border-black/10 px-2.5 py-1">
                    {tool.models}
                  </span>
                </div>

                <h3 className="mt-8 font-head text-3xl font-extrabold tracking-tight text-[#111111]">
                  {tool.name}
                </h3>
                <p className="mt-1 font-mono-tech text-xs uppercase tracking-[0.15em] text-neutral-500">
                  {tool.vendor}
                </p>

                <p className="mt-5 font-body text-neutral-600 leading-relaxed">
                  {tool.description}
                </p>

                <ul className="mt-7 space-y-3 flex-1">
                  {tool.uses.map((u) => (
                    <li
                      key={u}
                      className="flex items-start gap-3 font-body text-neutral-700"
                    >
                      <Check className="h-4 w-4 mt-1 shrink-0 text-[#2f4bff]" />
                      <span>{u}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AICapabilities;
